import React from "react";
import './Servic.css';

export default function () {
    return (

        <>
            <section className="sec-4-Servic">

                <div className="container">
                    <h2 className="text-center pt-2 fw-bold">CRYSTAL SERVICES</h2>

                    <p className="text-center pt-2">

                        Mauris mattis vitae libero eget iaculis. Donec et augue quis quam porttitor consectetur ut nec <br />sem. Integer sagittis viverra quam quis ultricies. Aenean risus nisl, consequat at nunc id, tincidunt <br />tristique mauris.
                    </p>

                    <div className="row justify-content-evenly pt-2">

                        <div className="col-12 col-md-3 coldiv ">

                            <h4 className="fw-bold text-color p-1">WEB DEVELOPMENT</h4>
                            <p>In suscipit, purus id ultrices sodales, nunc mi porta nibh, bibendum maximus sem mi id metus. Suspendisse faucibus suscipit diam.</p>
                        </div>

                        <div className="col-12 col-md-3 coldiv mt-3 mt-md-0">

                            <h4 className="fw-bold text-color p-1">DOMAIN HOSTING</h4>
                            <p>In suscipit, purus id ultrices sodales, nunc mi porta nibh, bibendum maximus sem mi id metus. Suspendisse faucibus suscipit diam.</p>
                        </div>

                        <div className="col-12 col-md-3 coldiv mt-3 mt-md-0">

                            <h4 className="fw-bold text-color p-1">WEB DESIGN</h4>
                            <p>In suscipit, purus id ultrices sodales, nunc mi porta nibh, bibendum maximus sem mi id metus. Suspendisse faucibus suscipit diam.</p>
                        </div>



                    </div>

                    <div className="row justify-content-evenly pt-md-4">

                        <div className="col-12 col-md-3 coldiv mt-3 mt-md-0">

                            <h4 className="fw-bold text-color p-1">RESPONSIVE THEMES</h4>
                            <p>In suscipit, purus id ultrices sodales, nunc mi porta nibh, bibendum maximus sem mi id metus. Suspendisse faucibus suscipit diam.</p>
                        </div>

                    </div>

                </div>

            </section>

            <section className="sub-section-servic mt-md-5 mt-3">  {/* sub section in servic */}

                <div className="container">
                    <h2 className="text-center text-white fe-bold pt-md-4">CRYSTAL NEWSLETTER</h2>
                    <p className="text-center text-white pt-2">

                        Mauris mattis vitae libero eget iaculis. Donec et augue quis quam porttitor consectetur ut nec <br />sem. Integer sagittis viverra quam quis ultricies. Aenean risus nisl, consequat at nunc id, tincidunt <br />tristique mauris.
                    </p>

                    <div className="row justify-content-evenly pt-3">

                        <input type="text" placeholder="Enter Your Email" className="col-12 col-md-5 bg-transparent p-2"/>

                        <button type="button" className="col-12 col-md-4 p-2 rounded sub-btn">

                            SUBSCRIBE NOW

                        </button>

                    </div>

                </div>

            </section>
        </>

    )
}